import { FormCheck } from 'react-bootstrap';
import { Deal } from '../models/shared/Deal';
import { useText } from '../context/TextContext';
import { useOrganization } from '../context/OrganizationContext';
import DealModalSection from './DealModalSection';
import Gravatar from './Gravatar';
import { AdvancedButton } from './AdvancedButton';
import { PATHS, ORGANIZATION_SETTINGS_TABS, QUERY_PARAMS } from '../utils/shared/constants';

interface Props {
    deal: Deal;
    onDealUpdate: (update: Partial<Deal>) => void;
    className?: string;
    readOnly?: boolean;
}

export default function MembersManagement(props: Props) {
    const text = useText();
    const { members } = useOrganization();

    const inviteLink = `${PATHS.ORGANIZATIONSETTINGS}?${QUERY_PARAMS.TAB}=${ORGANIZATION_SETTINGS_TABS.TEAM}`;

    if (members.length <= 1) {
        return null;
    }

    const toggleMember = (memberEmail: string) => {
        const assignedTo = props.deal.assignedTo || [];
        if (assignedTo.includes(memberEmail)) {
            props.onDealUpdate({
                assignedTo: assignedTo.filter(email => email !== memberEmail)
            });
        } else {
            props.onDealUpdate({
                assignedTo: [...assignedTo, memberEmail]
            });
        }
    }

    const assignedTo = props.deal.assignedTo || [];
    const assignedMembers = members.filter(member => assignedTo.includes(member.email));

    return (
        <DealModalSection
            title={text.members}
            alwaysVisibleChildren={
                <div className="mb-2 d-flex gap-1">
                    {assignedMembers.map(member => <Gravatar key={member.email} identifier={member.email} size='xs' default='wavatar' className='me-1' />)}
                </div>
            }
        >
            <div className='d-flex flex-column gap-2'>
                {members.map(member => {
                    const isAssigned = props.deal.assignedTo?.includes(member.email) || false;
                    return (
                        <div key={member.email} className='d-flex align-items-center gap-2'>
                            <FormCheck
                                type='checkbox'
                                checked={isAssigned}
                                onChange={() => toggleMember(member.email)}
                                disabled={props.readOnly}
                            />
                            <div className='flex-1 d-flex align-items-center gap-2'>
                                <Gravatar identifier={member.email} size='sm' default='wavatar' />
                                <div>{member.email}</div>
                            </div>
                        </div>
                    );
                })}
                {!props.readOnly && (
                    <AdvancedButton variant='clean' size='sm' icon='bi-person-plus' link={inviteLink}>
                        {text.inviteMember}
                    </AdvancedButton>
                )}
            </div>
        </DealModalSection>
    );
}